import './js/utils/polyfills';
import './svg';
// Important your main scss file here:
import './sass/styles.scss';

import InitFocusStyles from './js/focusStyles';
import InitMenuButtons from './js/menubuttons';
import InitSearchboxes from './js/searchboxes';
import InitMobileMenus from './js/mobilemenus';
import InitAlgoliaSearch from './js/components/algolia-search/search-algolia';
import InitFeedbackForm from './js/feedbackform';
import InitVideos from './js/videos';
import InitPjax from './js/cms-spa';
import Accordion from './js/components/accordion';
import ExternalLinks from './js/components/external-links';

const site = {
    /**
     * Initialises the site's modules.
     * Each module defines its own init function, this is just the glue.
     */
    init() {
        InitMenuButtons();
        InitFocusStyles();
        InitSearchboxes();
        InitMobileMenus();
        InitAlgoliaSearch();
        InitFeedbackForm();
        InitVideos();
        InitPjax();
        Accordion();
        ExternalLinks();
    },
};

site.init();
